module.exports = new __parcel__URL__("ambient-background-abstract-darkmode.972afcd9.svg").toString();